import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const KeyIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2081 6.87504L17.4164 3.66671M19.2498 1.83337L17.4164 3.66671L19.2498 1.83337ZM10.4406 10.6425C10.9139 11.1096 11.2902 11.6656 11.5477 12.2786C11.8052 12.8916 11.939 13.5495 11.9412 14.2145C11.9434 14.8794 11.8141 15.5382 11.5607 16.1529C11.3073 16.7676 10.9347 17.3262 10.4646 17.7963C9.99439 18.2665 9.43586 18.639 8.82112 18.8925C8.20639 19.1459 7.5476 19.2752 6.88268 19.273C6.21776 19.2708 5.55984 19.137 4.94682 18.8795C4.3338 18.6219 3.77777 18.2457 3.31076 17.7724C2.39238 16.8215 1.88421 15.548 1.8957 14.2261C1.90719 12.9042 2.43741 11.6396 3.37218 10.7049C4.30694 9.77011 5.57146 9.23988 6.89337 9.22839C8.21527 9.21691 9.48881 9.72508 10.4397 10.6435L10.4406 10.6425ZM10.4406 10.6425L14.2081 6.87504L10.4406 10.6425ZM14.2081 6.87504L16.9581 9.62504L20.1664 6.41671L17.4164 3.66671L14.2081 6.87504Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
